<template>
  <div class="box">
    <img src="../assets/img/logo.png" alt="" class="box_img" />
    <div class="baner">
      <div
        class="baner_item"
        v-for="(item, idx) in baneList"
        :key="idx"
        @click="goPage(item.path, item.num)"
      >
        <img :src="item.img" alt="" />
        <p>{{ item.name }}</p>
      </div>
    </div>
    <div class="login_ftr">
      <p>Copyright (c) 2020   京ICP备15005281号-1 All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  site_lw_time:'',
  site_kp_time:'',
  message:'',
  curTime:'',
  start:'',
  data () {
    return {
      baneList: [
        {
          name: '历史记录',
          img: require('../assets/img/lsjl.png'),
          path: '/Home'
        },
        {
          name: '会议论文投稿',
          img: require('../assets/img/lwgl.png'),
          path: '/agreement',
          num: 1
        },
        {
          name: '科普作品投稿',
          img: require('../assets/img/tg.png'),
          path: '/agreements',
          num: 2
        }
      ]
    }
  },
  components: {},
  methods: {
    async goPage (name, num) {
      const res = await this.$api.Home.getNameValueList()
      this.site_lw_time = res.data.site_lw_time
      this.site_kp_time = res.data.site_kp_time
      //console.log(this.site_lw_time,this.site_kp_time)
      if (num == 1) {
        if(this.site_lw_time == ""){
          this.message = '论文投稿未开启!'
          this.$message.error(this.message)
          return false
        }
        this.end = moment(this.site_lw_time).unix()
      }
      if (num == 2) {
        if(this.site_kp_time == ""){
          this.message = '科普投稿未开启!'
          this.$message.error(this.message)
          return false
        }
        this.end = moment(this.site_kp_time).unix()
      }

      if (num !== 0) {
        window.localStorage.setItem('typeNum', num)
      }

      if (name != '/Home') {
        this.curTime = moment().format('YYYY-MM-DD HH:mm:ss')
        this.start = moment(this.curTime).unix()
        if (this.start >= this.end) {
          const endTimeText = moment.unix(this.end).format('YYYY-MM-DD HH:mm:ss')
          this.$message.warning(`投稿时间于${endTimeText} 截止！`)
        } else {
          this.$router.push(name)
        }
      } else {
        this.$router.push(name)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  background: #000;
  width: 100%;
  height: 100%;
  background: url('../assets/img/bg.png') no-repeat center;
  background-size: 100% 100%;

  .baner {
    width: 800px;
    height: 340px;
    background-color: #ffffff;
    border-radius: 27px;
    box-sizing: border-box;
    padding: 70px 64px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;

    .baner_item {
      width: 200px;
      height: 200px;
      background-color: #e73917;
      border-radius: 5px;
      padding: 45px 0;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
      img {
        width: 58px;
        display: block;
        margin: 0 auto;
        height: 58px;
      }
      p {
        margin-top: 30px;
        color: #fff;
        font-size: 20px;
      }
    }
    .baner_item:first-of-type {
      background-color: #00589f;
    }
  }
  .box_img {
    width: 132px;
    height: 130px;
    display: block;
    margin: 0 auto;
    padding-top: 139px;
  }
}
</style>
